import mixinGetters from '@/store/mixins/field/getters'
import mixinActions from  '@/store/mixins/field/actions'

const source = 'survey/editing'

export default {
	namespaced: true,
	state: {
		all: {},
		notValid: [],
	},
	getters: {
		...mixinGetters,
		editSource (state, getters, rootState, rootGetters) {
			return rootGetters.editSources.commonSegment
		}
	},
	mutations: {
		setFields(state, fields) {
			state.all = fields
		},
	},
	actions: {
		...mixinActions
	} 
}
